import React from 'react';
import { getFormationSelectOptions } from '../utils/formationCatalog';

const FormationSelect = ({
  getContent,
  id,
  name,
  value,
  onChange,
  onFormationChange,
  required = false,
  className,
  placeholder = 'Sélectionnez une formation',
  defaultValue,
  valueField = 'title',
  ...props
}) => {
  const groups = getFormationSelectOptions(getContent);
  const selectProps = value !== undefined
    ? { value }
    : { defaultValue: defaultValue ?? '' };

  const handleChange = (e) => {
    onChange?.(e);
    if (!onFormationChange) return;
    const selected = e.target.value;
    let courseId = '';
    let title = selected;
    for (const group of groups) {
      const course = group.courses.find(
        (c) => (valueField === 'id' ? c.id : c.title) === selected
      );
      if (course) {
        courseId = course.id;
        title = course.title;
        break;
      }
    }
    onFormationChange({ courseId, title, value: selected });
  };

  return (
    <select
      id={id}
      name={name}
      onChange={handleChange}
      required={required}
      className={className}
      {...selectProps}
      {...props}
    >
      <option value="">{placeholder}</option>
      {groups.map((group) => (
        <optgroup key={group.specialtyId} label={group.label}>
          {group.courses.map((course) => (
            <option
              key={course.id}
              value={valueField === 'id' ? course.id : course.title}
            >
              {course.title}
            </option>
          ))}
        </optgroup>
      ))}
      {valueField !== 'id' && <option value="Autre formation">Autre formation</option>}
    </select>
  );
};

export default FormationSelect;
